import React from "react";
import CmmsSpareParts from "../features/cmmsSpareParts";

export default function CmmsSparePartsPage() {
  return (
    <CmmsSpareParts />
  );
}
